export default __webpack_public_path__ + "static/media/aptm.c24f4ff0.png";